import { useEffect } from 'react';

/**
 * useSEO
 * Lightweight per-route SEO helper for this client-rendered (Vite/React) SPA.
 * Updates the document title and the <meta name="description"> tag whenever
 * a page mounts, so each route (Home, Terms, Privacy, Cookies) can carry its
 * own title/description instead of always showing the default from index.html.
 *
 * Note: since this app has no SSR/prerendering, crawlers that don't execute
 * JavaScript will still only see the defaults set in index.html. For full
 * SEO coverage (unique meta per route in raw HTML), consider adding
 * prerendering (e.g. vite-plugin-ssr, react-snap) or migrating to a
 * framework with SSR (Next.js / Remix) down the line.
 */
const useSEO = (title, description) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
};

export default useSEO;
